'use client'

import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

// Portals children to <body> so fixed modals resolve in the root stacking
// context: a fixed/transformed ancestor with a z-index (e.g. the `fixed z-30`
// create container) would otherwise trap a child modal below it, so its own
// high z-index only competes within that ancestor (sits at z-30, below the
// z-50 header/banners). Mounts only after first client render to avoid a
// hydration mismatch.
export default function Portal({ children }) {
  const [mounted, setMounted] = useState(false)

  useEffect(() => setMounted(true), [])

  if (!mounted || typeof document === 'undefined') return null

  return createPortal(children, document.body)
}
